/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {verifySmsJanus} from '../api'

export const useMutationVerifySmsJanus = createReactQueryMutationHook('verifySmsJanus', verifySmsJanus)
